/*
 * Copyright (c) 2024.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

import {ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID} from '@angular/core';
import {provideHttpClient} from "@angular/common/http";
import {provideToastr} from "ngx-toastr";
import {provideAnimations} from "@angular/platform-browser/animations";

import {registerLocaleData} from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import {SihwConfirmService} from "../services/sihwconfirm/sihwconfirm.service";
import {BsModalService} from "ngx-bootstrap/modal";

//locale:
registerLocaleData(localeNl);
export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(),
    provideAnimations(),
    provideToastr({
      timeOut: 7500,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    }),
    {provide: LOCALE_ID, useValue: 'nl-NL'}, //nederlandse getallen etc
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
    SihwConfirmService,
    BsModalService //geen zin in modules overal, dus we zetten het hier neer
  ],
};
